import { Box, Button, Grid, Typography } from "@mui/material"


function Gallery() {
    return (
        <Grid container sx={{
            width: "100%",
            height: "60vh",
            backgroundImage: "url(/galleryBack.jpeg)",
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}>
            <Box sx={{
                textAlign: "center",
                backgroundColor: "rgba(0,0,0,.6)",
                height: "100%",
                width: "100%",
                p: 3,
                justifyContent: "center",
                alignContent: "center"
            }}>
                <Typography variant="subtitle2" mb={1} sx={{
                    textTransform: "uppercase",
                    fontWeight: "bold",
                    color: "white"
                }}>Zjistěte něco nás </Typography>
                <Typography variant="h2" sx={{
                    fontWeight: "bold",
                    color: "white"
                }}>Galerie</Typography>
                <Box sx={{
                    mt: 1.5,
                    gap: 4
                }}>
                    <Box sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "center"
                    }}>
                    </Box>
                    <Button variant="outlined" color='secondary'>
                        Zobrazit Galerii
                    </Button>
                </Box>
            </Box>
        </Grid>
    )
}

export default Gallery